import { render, staticRenderFns } from "./TakeConversation.vue?vue&type=template&id=f4a818d2&"
import script from "./TakeConversation.vue?vue&type=script&lang=js&"
export * from "./TakeConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports